module.exports = __webpack_public_path__ + "img/inbox-company.svg";